import { ANALYSIS_STATUS } from '@aibees/elephant/types/personality-analysis';
import { IconType } from '@aibees/shared/components';
import { SxStyle } from '@aibees/shared/theme';
import { BadgeProps, Theme } from '@mui/material';
import { PeopleEmailStatus, PeopleTableInfo } from '../../types';

export interface PeopleQuickInfoProps {
  className?: string;
  item: PeopleTableInfo;
}

export interface QuickInfoBadgeInfo {
  color?: BadgeProps['color'];
  icon?: IconType;
  text?: string;
  iconSx?: SxStyle;
  variant?: BadgeProps['variant'];
}

export const badgeMap: Record<
  | Exclude<
      PeopleEmailStatus,
      | PeopleEmailStatus.UNKNOWN
      | PeopleEmailStatus.NOT_FOUND
      | PeopleEmailStatus.ERROR
      | PeopleEmailStatus.DO_NOT_MAIL
      | PeopleEmailStatus.DOMAIN_NOT_FOUND
      | PeopleEmailStatus.DOMAIN_NOT_EXIST
      | PeopleEmailStatus.DOMAIN_NOT_ACCEPT
      | PeopleEmailStatus.EXPIRED
    >
  | ANALYSIS_STATUS
  | 'default',
  QuickInfoBadgeInfo
> = {
  default: {
    icon: 'questionMark',
    color: 'default',
  },
  [PeopleEmailStatus.VALID]: {
    text: 'A+',
    color: 'success',
    variant: 'filled',
  },
  [PeopleEmailStatus.INVALID]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [PeopleEmailStatus.LOCKED]: {
    icon: 'questionMark',
    color: 'default',
  },
  [PeopleEmailStatus.UPDATE]: {
    icon: 'notifications-active',
    color: 'primary',
  },
  [PeopleEmailStatus.CATCH_ALL]: {
    text: 'A+',
    color: 'success',
    variant: 'filled',
  },
  [ANALYSIS_STATUS.SUCCESS]: {
    text: 'A+',
    color: 'success',
    variant: 'filled',
  },
  [ANALYSIS_STATUS.SCRAPING_FAILED]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.ANALYSIS_FAILED]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.EMPTY_RESULT]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.INSUFFICIENT_DATA]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.LOW_CONFIDENCE]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.MISSING_CONFIGURATION]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.PROFILE_NOT_FOUND]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.SERVICE_NOT_AVAILABLE]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.TIMEOUT]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
  [ANALYSIS_STATUS.UNKNOWN_ERROR]: {
    icon: 'info-circle-outline',
    color: 'error',
  },
};

export const badgeColorMap: Record<
  | Exclude<
      PeopleEmailStatus,
      | PeopleEmailStatus.UNKNOWN
      | PeopleEmailStatus.NOT_FOUND
      | PeopleEmailStatus.ERROR
      | PeopleEmailStatus.DO_NOT_MAIL
      | PeopleEmailStatus.DOMAIN_NOT_FOUND
      | PeopleEmailStatus.DOMAIN_NOT_EXIST
      | PeopleEmailStatus.DOMAIN_NOT_ACCEPT
      | PeopleEmailStatus.EXPIRED
    >
  | ANALYSIS_STATUS
  | 'default',
  (theme: Theme) => string
> = {
  default: (theme) => theme.palette.grey[400],
  LOCKED: (theme) => theme.palette.grey[400],
  CATCH_ALL: (theme) => theme.palette.warning[100],
  VALID: (theme) => theme.palette.success[400],
  INVALID: (theme) => theme.palette.error[100],
  UPDATE: (theme) => theme.palette.primary[100],
  [ANALYSIS_STATUS.SUCCESS]: (theme) => theme.palette.success[400],
  [ANALYSIS_STATUS.SCRAPING_FAILED]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.ANALYSIS_FAILED]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.EMPTY_RESULT]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.INSUFFICIENT_DATA]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.LOW_CONFIDENCE]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.MISSING_CONFIGURATION]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.PROFILE_NOT_FOUND]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.SERVICE_NOT_AVAILABLE]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.TIMEOUT]: (theme) => theme.palette.error[100],
  [ANALYSIS_STATUS.UNKNOWN_ERROR]: (theme) => theme.palette.error[100],
};
